import styled from 'styled-components';

export const TagCardWrap = styled.div<{ isMargin: boolean; isBox: boolean }>`
	display: ${({ isBox }) => (isBox ? 'inline-block' : 'block')};
	display: inline-block;
	margin-right: 6px;
	margin-right: ${({ isMargin }) => isMargin && '8px'};
	cursor: pointer;
	& .tag-info {
		margin-bottom: 10px;
		> span {
			color: #a9adba;
		}
	}

	& .ant-popover-title {
		color: #6c788c;
		font-size: 12px;
	}
`;
